import React from "react";
import { FaFilePdf } from "react-icons/fa";


const catalogs = [
    {
        title: "Product Catalog 2025, Bio & Eco-Friendly Solutions",
        desc: "Complete range of crop protection and agricultural solutions. Sustainable and eco-friendly agricultural product portfolio.",
        file: "/img/Goodweel.pdf"
    }
];

const CatalogSection = () => {
    return (
        <section className="catalog-section">
            <div className="container">

                {/* HEADING */}
                <div className="text-center mb-5">
                    <h6 className="section-subtitle">PRODUCT CATALOG</h6>
                    <h2 className="section-title">
                        Download Our <span>Latest Catalog</span>
                    </h2>
                    <p className="section-desc">
                        Explore our complete range of agricultural products, technical
                        specifications, and solutions designed for Indian farming needs.
                    </p>
                </div>

                {/* CATALOG CARDS */}
                <div className="row justify-content-center">
                    {catalogs.map((item, index) => (
                        <div className="col-lg-8 col-md-8 mb-4" key={index}>
                            <div className="catalog-card">

                                <div className="catalog-icon">
                                    <FaFilePdf size={50} color="red" />
                                </div>

                                <h4>{item.title}</h4>
                                <p>{item.desc}</p>

                                <a
                                    href={item.file}
                                    target="_blank"
                                    rel="noreferrer"
                                    download
                                    className="catalog-btn"
                                >
                                    Download PDF
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default CatalogSection;
